import {Component, DestroyRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {IconService} from './services/icon.service';
import {PortalMessageBroker} from './portal/portal-message-broker';
import {ContextInfoService, WellKnownJustFarmingProperties} from './portal/context-info.service';
import {MatomoTracker} from '@ngx-matomo/tracker';
import {Router} from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  private readonly _destroyRef = inject(DestroyRef);

  runningInPortal$: Observable<boolean>;

  constructor(
    iconService: IconService, // INFO: use for instantiation
    private portalMessageBroker: PortalMessageBroker,
    private oidcSecurityService: OidcSecurityService,
    private contextInfoService: ContextInfoService,
    private readonly tracker: MatomoTracker,
    protected router: Router,
  ) {
    this.runningInPortal$ = this.portalMessageBroker.runningInPortal$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
      );

    this.contextInfoService.contextInfo$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(contextInfo => {
        let analytics = contextInfo?.properties.get(WellKnownJustFarmingProperties.ANALYTICS);
        if (analytics === true) {
          this.tracker.setConsentGiven();
        } else {
          this.tracker.forgetConsentGiven();
        }
      });
  }

  doLogout(): void {
    this.oidcSecurityService.logoff();
  }

  get userInfo$(): Observable<any> {
    return this.oidcSecurityService.userData$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        map(value => value.userData),
      );
  }

  /**
   * Prüft ob aktuelle Route im Admin-Bereich ist
   * Wird für CSS-Klassen-Binding verwendet um Admin-Seiten
   * vom Wizard-Layout-System auszuschließen
   */
  get isAdminPage(): boolean {
    return this.router.url.includes('/admin');
  }
}
